import Alpine from 'alpinejs';

interface ListboxNavigateState {
    $el: HTMLElement;
    onNavigate: (index: string) => void;
}

export function registerListboxNavigate(): void {
    Alpine.data('listboxNavigate', (): ListboxNavigateState => ({
        $el: {} as HTMLElement,

        onNavigate(index: string): void {
            const inputs = this.$el.querySelectorAll<HTMLInputElement>('[data-url]');
            const input = inputs[parseInt(index)];

            if (!input?.dataset.url) {
                return;
            }

            if (input.dataset.newWindow === '1') {
                window.open(input.dataset.url, '_blank');
            } else {
                window.location.href = input.dataset.url;
            }
        },
    }));
}
